function helperDeleteProperty (obj, property) {
  try {
    delete obj[property]
  } catch (e) {
    obj[property] = undefined
  }
}

module.exports = helperDeleteProperty



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperDeleteProperty.js
// module id = 303
// module chunks = 98